// The card message for one piece in the bag: an optional note saved on that cart line as the
// "Card message" attribute. Shopify shows it in checkout, on the order and on the packing slip,
// so the words travel with the right piece. Rendering is a pure function; the drawer wires it up.
import { esc } from '../lib/format.js';

export const NOTE_KEY = 'Card message';
export const NOTE_MAX = 200;

/** markup for one line's note: a link to add one, the saved words, or the open editor */
export function noteHTML(line, { open = false, draft } = {}) {
  const saved = line.attributes?.[NOTE_KEY] || '';
  const id = esc(line.id);
  if (open) {
    const text = draft ?? saved;
    return `<div class="note open" data-note-for="${id}">
      <label class="note-lbl" for="note-${id}">Words for the story card <small>(optional)</small></label>
      <textarea data-clarity-mask="true" id="note-${id}" data-note-text="${id}" maxlength="${NOTE_MAX}" rows="3" placeholder="Happy birthday, I'm so proud of you. Love, Mom">${esc(text)}</textarea>
      <div class="note-row"><span class="note-count" aria-live="polite">${NOTE_MAX - text.length} left</span>
        <button type="button" class="note-cancel" data-note-cancel="${id}">Cancel</button>
        <button type="button" class="btn btn-navy note-save" data-note-save="${id}">Save</button></div>
    </div>`;
  }
  if (saved) return `<div class="note" data-note-for="${id}"><p class="note-saved"><span class="sr">Card message: </span>“${esc(saved)}”</p><button type="button" class="note-link" data-note-open="${id}">Edit message</button></div>`;
  return `<div class="note" data-note-for="${id}"><button type="button" class="note-link" data-note-open="${id}">+ Add a message for the card</button></div>`;
}

// tidy what was typed: keep single line breaks, drop runs of blank lines and stray spaces
export const cleanNote = (s) => String(s || '').replace(/\r/g, '').replace(/[ \t]+/g, ' ').replace(/\n{3,}/g, '\n\n').trim().slice(0, NOTE_MAX);
